import { render } from "./SessionSettings.vue?vue&type=template&id=15539e45"
import script from "./SessionSettings.vue?vue&type=script&lang=js"
export * from "./SessionSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__